import { createNavbar } from '@/modules/misc/common/navbar/components/navbar';
import { createVCAvatarDropdown } from '@/modules/misc/common/navbar/components/vc-navigation-dropdown';
import breakpointConfig from '@/modules/misc/common/navbar/linksPosition/breakpointConfig.json';

import config from './config.json';
import configVC from './config-vc.json';
import { enhanceLinksWithData } from './utils/data.js';
import { filterLinks } from './utils/filtering.js';
import { addResizeListener } from './utils/resizeListener.js';
import { updateFavoriteRooms } from './utils/updateFavoriteRooms.js';
import { updateNumUnreadEnquiries } from './utils/updateNumUnreadEnquiries.js';
import { updateProfilePicture } from './utils/updateProfilePicture.js';
import { updateUserName } from './utils/updateUserName.js';

const navbarBreakpointConfig = {
  ...breakpointConfig,
  ...(window._NAVBAR_BREAKPOINT_CONFIG || {}),
};

async function getUser() {
  return App.es6.shared.user_data.getUser();
}

function addLogoTracking(user) {
  const logo = document.querySelector('.js-header-logo');

  if (!logo) {
    return;
  }

  logo.addEventListener('click', () => {
    let section = 'navbar_guest';
    if (user.type === 'user') {
      section = 'navbar_customer';
    } else if (user.type === 'manager') {
      section = 'navbar_manager';
    }

    App.track.event('navbar_interaction', {
      section,
      element: 'tagvenue_logo',
      interaction: 'click',
    });
  });
}

function handleLogoRedirect(user) {
  const logo = document.querySelector('.js-header-logo');

  if (!logo) {
    return;
  }

  logo.addEventListener('click', (e) => {
    if (user.type === 'manager') {
      e.preventDefault();
      window.location.href = '/venue-cabinet/enquiries/all';
    }
  });
}

async function main() {
  const user = await getUser();
  const numUnreadThreads = parseInt(user.unreadEnquiries || 0, 10);
  const showDot = numUnreadThreads > 0;

  let links = config[user.type];
  links = filterLinks({ links, user });
  links = enhanceLinksWithData({ links, user });
  createNavbar({ links, user, showDot });

  const VCDropdownLinks = configVC.links || [];
  createVCAvatarDropdown({ links: VCDropdownLinks, user });

  addLogoTracking(user);
  handleLogoRedirect(user);
}

function addListeners() {
  addResizeListener(
    navbarBreakpointConfig.breakpoints,
    main,
  );

  $.subscribe('enquires:updateCount', () => {
    updateNumUnreadEnquiries();
  });

  $.subscribe('wishList:change', savedRoomsCount => {
    updateFavoriteRooms(savedRoomsCount);
  });

  $.subscribe('profilePicture:change', url => {
    updateProfilePicture(url);
  });

  $.subscribe('userName:change', obj => {
    updateUserName(obj);
  });

  // eslint-disable-next-line no-use-before-define
  $.subscribe('loginState:change', () => reloadNavbar());
}

function loadNavbar() {
  const interval = setInterval(() => {
    if (window?.App?.es6?.shared?.user_data) {
      clearInterval(interval);
      main().then(() => {
        addListeners();
      });
    }
  }, 100);
}

export default loadNavbar;

export function reloadNavbar() {
  window.__TGV_USER_DATA_LOAD(() => {
    loadNavbar();
  });
}
